export default ({ children, type, onClose }) => {
    return (
        <div className={"popup " + ( type ? type : "" )}>
            <span className="popup__close" onClick={() => onClose(null)}><img src="/assets/close-icon.svg"></img></span>
            { children }
        </div>
    )
}
